import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { API } from '../../shared/constants/api.constants';
import { ResponseWrapper, createRequestOption } from '../../shared';
import { Item } from './../announcement/Announcement.model';
import { Announcementmodel } from './Announcement.model';
import {Item as ItemInvoice} from '../invoice-management/item.model';


@Injectable()
export class Announcementservice {

    private resourceUrl = API.host + 'invoices/created';
    private resourceApproveInvoiceUrl = API.host + 'invoices/approved';
    private resourceUrlcpn = API.host + 'InvoicePortal/companies/mycompany';
    private resourceSymbolsUrl = API.host + 'InvoicePortal/filter-invoice-symbol';
    
    private resourceUrlSearchCode = API.host + 'Announcement/Announcement-SearchCode';
    private resourceUrlSave = API.host + 'Announcement/Save';
    private resourceUrlUpdate = API.host + 'Announcement/Update';
    private resourceUrLoadlist = API.host + 'InvoicePortal/Announcement-LoadList';
    private resourceUrUpdateStatus = API.host + 'Announcement/UpdateAnnouncementStatus';
    private resourceUrlRemove = API.host + 'Announcement/Remove';
    private resourceUrlInvoiceAdjustment = API.host + 'adjust-invoice/search';
    private resourceUrlIsExit = API.host + 'Announcement/Announcement-IsExit';

    private resourceUrlInvoice = API.host + 'invoices';
    private resourcetemplatesUrl = API.host + 'InvoicePortal/InvoicePortal-templates';

    constructor(private http: Http) { }



    // queryCreated(req?: any): Observable<ResponseWrapper> {
    //     const options = createRequestOption(req);
    //     return this.http.get(this.resourceUrl, options)
    //         .map((res: Response) => this.convertResponse(res));
    // }

    // private convertResponse(res: Response): any {
    //     if (!res || !res.json) {
    //         throw 'Invalid Code';
    //     }

    //     const jsonResponse = res.json().data;
    //     return new ResponseWrapper(res.headers, jsonResponse, res.status);
    // }

    getSymbols(invoiceTemplateId): Observable<ResponseWrapper> {
        return this.http.get(this.resourceSymbolsUrl + '/' + invoiceTemplateId).map((res: Response) => {
            const jsonResponse = res.json().data;
            return new ResponseWrapper(res.headers, jsonResponse, res.status);
        });
    }

    find(id: number): Observable<Item> {
        return this.http.get(`${this.resourceUrlcpn}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    findAnnouncement(id: number): Observable<Item> {
        return this.http.get(`${this.resourceUrlcpn}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    findInvoice(id: number): Observable<ItemInvoice> {
        return this.http.get(`${this.resourceUrlInvoice}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    searchcode(id: number): Observable<any> {
        
        return this.http.get(`${this.resourceUrlSearchCode}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    Save(oj: Announcementmodel): Observable<any> {
        
        const copy = this.convert(oj);
        return this.http.post(`${this.resourceUrlSave}`, oj).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    Update(oj: Announcementmodel): Observable<any> {

        const copy = this.convert(oj);

        return this.http.post(`${this.resourceUrlUpdate}`, oj).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

  
    private convert(item: Announcementmodel): Announcementmodel {
        const copy: Announcementmodel = Object.assign({}, item);
        return copy;
    }

    LoadList(id: number, actiontype: number): Observable<Announcementmodel> {
        
        return this.http.get(`${this.resourceUrLoadlist}/${id}/${actiontype}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    UpdateannouncementStatus(oj: Announcementmodel): Observable<string> {
        
        return this.http.post(`${this.resourceUrUpdateStatus}`, oj).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    // queryInvoiceAdjustment(req?: any): Observable<ResponseWrapper> {
        
    //     const options = createRequestOption(req);
    //     return this.http.get(this.resourceUrlInvoiceAdjustment, options)
    //         .map((res: Response) => this.convertResponse(res));
    // }

    Remove(AnnouncementID: number, UserSID: number)
    {
        
        let ann = new Announcementmodel();
        ann.id = AnnouncementID;
        ann.UpdatedBy = UserSID;
        const options = createRequestOption(ann);
        return this.http.post(`${this.resourceUrlRemove}`, ann).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    IsExit(id: number, announcementType: number): Observable<string> {
        return this.http.get(`${this.resourceUrlIsExit}/${id}/${announcementType}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }

    getTemplates(companyId: number): Observable<ResponseWrapper> {
        return this.http.get(this.resourcetemplatesUrl + '/' + companyId )
            .map((res: Response) => this.convertResponse(res));
    }

    private convertResponse(res: Response): any {
        if (!res || !res.json) {
            throw 'Invalid Code';
        }
        const jsonResponse = res.json().data;
        return new ResponseWrapper(res.headers, jsonResponse, res.status);
    }
}
